import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/index";

let middleware = [];
if (process.env.NODE_ENV === "development") {
  middleware = [...middleware, thunk];
} else {
  middleware = [...middleware, thunk];
}

export default createStore(
  rootReducer,
  compose(applyMiddleware(...middleware)),
);
